const DEFAULT_API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:3400';

const globalConfig = window.__SHABU_ADMIN__ ?? {};

export const API_BASE_URL = globalConfig.apiBaseUrl ?? DEFAULT_API_URL;

// Get admin token from environment variable
const ADMIN_TOKEN = import.meta.env.VITE_ADMIN_TOKEN;

async function request(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers ?? {})
  };

  // Add Authorization header if admin token exists
  if (ADMIN_TOKEN) {
    headers.Authorization = `Bearer ${ADMIN_TOKEN}`;
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers,
    ...options
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function getOrders() {
  const result = await request('/orders');
  return result.data ?? [];
}

export async function updateOrderStatus(orderId, status) {
  return request(`/orders/${orderId}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status })
  });
}

export async function getTables() {
  const result = await request('/tables');
  return result.data ?? [];
}

export async function getMenuItems() {
  const result = await request('/menu');
  return result.data ?? [];
}

export async function uploadImage(file) {
  const formData = new FormData();
  formData.append('image', file);

  const response = await fetch(`${API_BASE_URL}/api/upload/image`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${ADMIN_TOKEN}`
    },
    body: formData
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || 'Upload failed');
  }

  return response.json();
}
